/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditNewScorecardAttributeRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.edit.new-scorecard.attribute',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditNewScorecardAttributeRoute);
